import { type CVEditingSection, type FullCV } from '@cibli/shared';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';

interface HobbiesSectionProps {
  hobbies: FullCV['hobbiesAndInterests'];
  onEdit?: (section: CVEditingSection) => void;
  overlayBg?: string;
}

export default function HobbiesSection({ hobbies, onEdit, overlayBg }: HobbiesSectionProps) {
  const { t } = useCVTranslation();
  const editable = onEdit !== undefined;

  if (!hobbies?.length && !editable) return null;

  const handleEdit = () => {
    if (onEdit) onEdit('hobbiesAndInterests');
  };

  return (
    <EditableSection onEdit={handleEdit} editable={editable} splitable>
      <div>
        <h2 className="text-[11px] font-black uppercase tracking-widest text-current pb-1.5 mb-1.5">
          {t('CV.hobbiesAndInterests')}
        </h2>
        <div className="flex flex-wrap gap-1">
          {(hobbies ?? []).map((hobby, index) => (
            <span
              key={index}
              style={{ backgroundColor: overlayBg }}
              className="text-[10px] text-current px-1.5 py-0.5 rounded leading-snug text-center whitespace-nowrap"
            >
              {hobby}
            </span>
          ))}
        </div>
      </div>
    </EditableSection>
  );
}
